import React from 'react';
import {
  FDBackButton,
  FDBadge, FDList, FDPrimaryActionButton,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  TaskListItem,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/TaskListItem';
import {
  useEmailTabContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/EmailTabContext';
import {
  EMAIL_EDITOR_SECTION,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections/index';
import { SectionPaper } from '../SectionPaper';

export const TasksSection = ({
  title,
  taskCount,
  setCurrentSection,
  actionItemResources,
  selectedItemMap,
  isClientAssigned,
  buttonLabel,
}) => {
  const { handleClickAddActionItem } = useEmailTabContext();

  return (
    <SectionPaper height={'100%'} flex={1}>
      <FDStack direction={'column'} justifyContent={'space-between'} height={'100%'}>
        <FDStack direction={'column'} spacing={4}>
          <FDStack spacing={3} alignItems={'center'}>
            <FDTitleText value={title} />
            <FDBadge appearance="standard" value={taskCount} />
          </FDStack>
          <FDList variant={'separated'}>
            {actionItemResources.map((actionItemResource) => {
              return (
                <TaskListItem
                  actionItemResource={actionItemResource}
                  isSelected={selectedItemMap[actionItemResource.id()]}
                  isClientAssigned={isClientAssigned}
                />
              );
            })}
          </FDList>
        </FDStack>
        <FDStack direction={'row'} justifyContent={'space-between'} paddingY={1}>
          <FDBackButton onClick={() => setCurrentSection(EMAIL_EDITOR_SECTION)} size={'lg'} />
          <FDPrimaryActionButton
            size={'lg'}
            icon={'add'}
            onClick={() => handleClickAddActionItem(isClientAssigned)}
            label={buttonLabel}
          />
        </FDStack>
      </FDStack>
    </SectionPaper>
  );
};

TasksSection.defaultProps = {
  isClientAssigned: false,
};

TasksSection.propTypes = {
  title: PropTypes.string.isRequired,
  taskCount:
  PropTypes.number.isRequired,
  setCurrentSection:
  PropTypes.func.isRequired,
  actionItemResources:
  PropTypes.array.isRequired,
  isClientAssigned: PropTypes.bool,
  selectedItemMap: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string.isRequired,
};
